import Vue from 'vue'
import myPlugin from './plugins/myPlugin'
// import Cookies from 'js-cookie'
import VueLodash from 'vue-lodash'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { ElementTiptapPlugin } from './element-tiptap.min';
import './index.css';
import hljs from 'highlight.js'
// import hljs from 'highlight.js/lib/core';
// import javascript from 'highlight.js/lib/languages/javascript';
// import css from 'highlight.js/lib/languages/css';
// hljs.registerLanguage('javascript', javascript);
// hljs.registerLanguage('css', css);

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog' // error log
import './permission' // permission control
// import './mock' // simulation data
import VueClipBoard from 'vue-clipboard2'
import * as filters from './filters' // global filters
// 引入阿里图标
import '@/assets/iconfont/iconfont.css'

import ChangeSys from 'sfc_sys_change'
// 新图片放大
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 引入全局组件
import components from '@/components/index.js'
Vue.use(components)
// 按钮权限
import Directives from './directive/index'
Vue.use(Directives)
// 图片预览 使用指令v-viewer 或 <viewer><img/></viewer>
Vue.use(Viewer)
Vue.use(VueClipBoard)
// 使用 系统切换
Vue.use(ChangeSys)

Vue.use(VueLodash)
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(ElementTiptapPlugin, {
  lang: "zh",
  // spellcheck: false,
});
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(myPlugin,{
  test:'hello world'
})


Vue.config.productionTip = false
Vue.prototype.hljs = hljs;
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
